import { FC, PropsWithChildren } from "react";

import { TDrawerCloseFunction } from "@ryde/shared";

import { MenuDrawerBackdrop } from "./menu-backdrop";
import { MenuDrawerWrapper } from "./menu-wrapper";

interface IMenuBaseDrawerProps extends PropsWithChildren {
  onCloseDrawer: TDrawerCloseFunction;
  customWidth?: string;
  drawerNumber?: number;
}

export const MenuBaseDrawer: FC<IMenuBaseDrawerProps> = ({
  onCloseDrawer,
  children,
  customWidth,
  drawerNumber,
}) => {
  return (
    <MenuDrawerBackdrop onCloseDrawer={onCloseDrawer}>
      <MenuDrawerWrapper customWidth={customWidth} drawerNumber={drawerNumber}>
        {children}
      </MenuDrawerWrapper>
    </MenuDrawerBackdrop>
  );
};
